module.exports = __webpack_public_path__ + "static/maja-5284e5186c4a0920315e0fc17acd402e.jpg";